import './styles.scss'
import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { useSelector, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import _get from 'lodash.get'

import { botConsole } from 'api'
import { conversationAct } from 'redux_new/actions'
import { closeAllTabs } from 'redux/actions/tabs'
import { getUser, removeAllConversations } from 'redux/actions/conversations/conversations'
import operatorActions from 'redux/actions/user'
import { fetchUsers } from 'redux/actions/cv_users'
import { fetchAssignedUsers } from 'redux/actions/assignedUsers'
import poolLists from 'redux/poolLists/actions'
import inChatRedux from 'redux/inchat/actions'
import UserTabs from 'components/UserTabs'
import Chat from 'components/Chat'
import ChatChannelPlugins from 'components/Chat/ChatChannels/ChatChannelPlugins'
import { getStaticImage } from 'utils/statics'
import ALLOWED_DOMAINS from 'constants/allowed-domains'
import SearchResultsView from '../SearchResultsView'
import { CHANNELINCHAT } from 'constants/channels'
import InChatSections from 'components/InChatView/InChatSections'
import InChatPlugins from 'components/InChatView/InChatPlugins'
import { lang } from 'utils/helpers'

const MainView = () => {
  const { tabs, user, conversations, inchat, companies } = useSelector(store => store)
  const { frontOptions } = user
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [setting, setSetting] = useState({})
  const [isOpenPluginsPanel, setIsOpenPluginsPanel] = useState({})
  const conversation = CHANNELINCHAT.includes(tabs.activeChannel)? inchat.conversations[tabs.activeUser]: conversations[tabs.activeUser]
  const channel = CHANNELINCHAT.includes(tabs.activeChannel)? tabs.activeChannel : _get(conversation, 'user.channels.0.channel')
  const urlParams = new URLSearchParams(location.search)
  const userId = urlParams.get('user_id')
  const section = urlParams.get('section')
  const showPluginsInChat = (!section && userId === tabs.activeChannel) || CHANNELINCHAT.includes(tabs.activeChannel)
  const showPluginsChannels = (conversation && setting && !CHANNELINCHAT.includes(tabs.activeChannel))

  const closeAllAct = bindActionCreators({ closeAllTabs, removeAllConversations }, dispatch)
  useEffect(() => {
    if(location.pathname === '/dashboard/conversations/inchat') {
      if(userId && CHANNELINCHAT.includes(tabs.activeChannel)){
        getDataInchat()
        return
      } else if(tabs.activeUser && CHANNELINCHAT.includes(tabs.activeChannel) && !section){
        history.push(`${location.pathname}?user_id=${tabs.activeUser}`)
        return
      } else {
        if (['drafts', 'threads', 'mentions'].includes(section)) {
          return
        }
      }
    }
    if (userId) {
      if(CHANNELINCHAT.includes(tabs.activeChannel)){
        dispatch(inChatRedux.getConversation(userId))
        return
      }
      getData()
    } else if (tabs.activeUser && (location.pathname === '/dashboard/conversations/users' || location.pathname === '/dashboard/conversations/assignations' || location.pathname === '/dashboard/conversations/inchat')) {
      history.push(`${location.pathname}?user_id=${tabs.activeUser}`)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  const getData = async () => {
    try {
      await dispatch(getUser(userId))
    } catch (error) {
      await dispatch(inChatRedux.getConversation(userId))
    }
  }

  const getDataInchat = async () => {
    try {
      await dispatch(inChatRedux.getConversation(userId))
    } catch (error) {
      await dispatch(getUser(userId))
    }
  }

  useEffect(() => {
    if (
      !tabs.users.length
      && [
        frontOptions.poolSelectType?.value,
        frontOptions.selectTypeAssigned?.value,
        frontOptions.poolListSelectType?.value
      ].includes('openedTabs')
    ) {
      dispatch(operatorActions.updateOperator({
        ...user,
        frontOptions: {
          ...frontOptions,
          poolSelectType: { value: 'all', label: lang('dashboard_all') },
          selectTypeAssigned: { value: 'all', label: lang('dashboard_all') },
          poolListSelectType: { value: 'all', label: lang('dashboard_all') }
        }
      }))

      if (frontOptions.poolSelectType?.value === 'openedTabs') {
        dispatch(fetchUsers({
          order: frontOptions.poolOrder,
          withPendingMsg: frontOptions.switchPending,
          withNotAssigned: frontOptions.poolNotAssigned,
          outbound: frontOptions.poolMainOutbound,
          selectType: null,
          channels: frontOptions.poolChannels,
          brands: frontOptions.poolBrandsAndDelegations?.brands || [],
          delegations: frontOptions.poolBrandsAndDelegations?.delegations || []
        }))
      }
      if (frontOptions.selectTypeAssigned?.value === 'openedTabs') {
        dispatch(fetchAssignedUsers({
          order: frontOptions.orderAssigned,
          withPendingMsg: frontOptions.switchPendingAssigned,
          onlyAssignedToMe: frontOptions.checkedOnlyToMeAssigned,
          outbound: frontOptions.outboundAssigned,
          selectType: null,
          channels: frontOptions.channelsAssigned,
          brands: frontOptions.brandsAndDelegationsAssigned?.brands || [],
          delegations: frontOptions.brandsAndDelegationsAssigned?.delegations || [],
          categories: frontOptions.categoriesAssigned || []
        }))
      }
      if (frontOptions.poolListSelectType?.value === 'openedTabs') {
        dispatch(poolLists.listsAndUsers({
          selectType: null,
          channels: frontOptions.poolListChannel,
          brands: frontOptions.poolListBrandsAndDelegations?.brands || [],
          delegations: frontOptions.poolListBrandsAndDelegations?.delegations || []
        }))
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs.users])

  useEffect(() => {
    if (userId && !CHANNELINCHAT.includes(tabs.activeChannel)) getSetting(userId)

    return () => setSetting({})
  }, [userId, tabs.activeChannel])

  const togglePluginsPanel = () => setIsOpenPluginsPanel(!isOpenPluginsPanel)

  const getSetting = async (userId) => {
    if (ALLOWED_DOMAINS.type === 'OP') {
      const { data } = await botConsole.getSetting({ userId })
      setSetting(data)
    }
  }

  const onCloseAllTabs = () => {
    closeAllAct.closeAllTabs()
    closeAllAct.removeAllConversations()
    history.replace(location.pathname)
    dispatch(conversationAct.removeAll())
  }

  return (
    <div
      className={`
        main-view
        ${!isOpenPluginsPanel ? 'main-view--plugins-panel-closed' : ''}
      `}
    >
      <div
        className={`
          main-view__chats-container
          ${section ? 'main-view__chats-container--section' : ''}
        `}
        style={{
          marginRight: tabs.activeUser ? '10px' : null
        }}
      >
        { section
          ?
          <InChatSections page={section} />
          :
          <>
            <div className='main-view__chats-tabs'>
              <div className='main-view__tabs-container'>
                <UserTabs users={tabs.users} activeChannel={tabs.activeChannel} />
              </div>
              {tabs.users.length !== 0 ? (
                <button
                  title={I18n.t('dashboard_close-all-tabs')}
                  className={`
                    main-view__icon-btn
                    ${!isOpenPluginsPanel ? 'main-view__icon-btn--plugins-panel-closed' : ''}
                  `}
                  onClick={onCloseAllTabs}
                >
                  <figure>
                    <img
                      src={getStaticImage('/icons/orange-brand/icon-close-dark.svg')}
                      alt={I18n.t('close_all_tabs')}
                    />
                  </figure>
                </button>
              ) : null}
            </div>
            {tabs.activeUser ? (
              <Chat
                setting={setting}
                getSetting={getSetting}
              />
            ) : (
              <SearchResultsView />
            )}
          </>
        }
      </div>
      {showPluginsChannels ? (
        <ChatChannelPlugins
          isOpen={isOpenPluginsPanel}
          toggle={togglePluginsPanel}
          user={conversation.user}
          operator={user}
          plugins={conversation.plugins}
          setting={setting}
          composer={conversation.composer}
          dispatch={dispatch}
          channel={channel}
          plan={companies.plan}
        />
      ) : showPluginsInChat ? <InChatPlugins
        isOpen={isOpenPluginsPanel}
        toggle={togglePluginsPanel}
      /> : null}
    </div>
  )
}

export default MainView
